import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class MailFetchAPI {

    //Function to get business by code 
    static async sendMail(data, token) {
        const res = await server(`/mail`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }
}